import { render, staticRenderFns } from "./setMealOrder.vue?vue&type=template&id=64e5fa1e&scoped=true"
import script from "./setMealOrder.vue?vue&type=script&lang=js"
export * from "./setMealOrder.vue?vue&type=script&lang=js"
import style0 from "./setMealOrder.vue?vue&type=style&index=0&id=64e5fa1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5fa1e",
  null
  
)

export default component.exports